import React from 'react'
import { useQuery } from "@apollo/client"
import { filter, map, sortBy } from 'lodash'
import { useNavigate } from "react-router-dom"

import AppFrame from '../AppFrame'
import Services from './Services/Services'
import About from './Home/About'
import MissionStatement from './Home/MissionStatement'
import { QUERY_HOME_DATA } from '../data/services/graphqlQueries'
import { generateAddress, generatePhone, generateFax } from '../helpers/clinic'
import Announcements from './Home/Announcements'
import { displayHours } from '../helpers/officeHours'
import SectionHeader from '../components/SectionHeader'
import HomeMap from './Home/Map'
import SplashCarousel from '../components/SplashCarousel'
import Social from './Home/Social'
import Clinics from './Home/Clinics'
import ClinicButtons from './Home/ClinicButtons'
import Loading from '../components/Loading'

export default ({globalData, clinic}) => {
  
  const navigate = useNavigate()
  const { loading, error, data } = useQuery(QUERY_HOME_DATA, {
    notifyOnNetworkStatusChange: true
  })

  const clinicAnnouncements = filter(globalData.announcements, (a) => {
    if (!clinic) return a.clinics.length === globalData.clinics.length || a.clinics.length === 0
    return a.clinics.includes(clinic.url)
  })

  const showAnnouncements = clinicAnnouncements.length > 0

  if (loading) {
    return (
      <AppFrame data={globalData}>
        <Loading />
      </AppFrame>
    )
  }

  return (
    <AppFrame data={globalData}>
      
      <SplashCarousel data={data.splashCarousels} clinic={clinic} />

      
      {
        clinic && 
        <div className="max-w-6xl mx-auto px-4 pb-8 min-h-[300px]">
          <div>
            <SectionHeader title={clinic ? clinic.name : 'Eye Clinics of Seattle'} subtitle={clinic ? 'Eye Clinics of Seattle' : null} />
          </div>
          {
            clinic.bulletinLarge !== null &&
            <div className="mb-8">
               <div className="ecs-html" dangerouslySetInnerHTML={{__html: clinic.bulletinLarge.html}} ></div>
            </div>
          }
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="uppercase text-sm font-semibold tracking-[1px] md:tracking-[2px] mb-8">
              {
                clinic &&
                <React.Fragment>
                  {generateAddress(clinic, false, false)}
                  <div className="block">
                    tel: {generatePhone(clinic.phone, false)}
                  </div>
                  <div className="block mb-2">
                    fax: {generateFax(clinic.fax, false)}
                  </div>
                  <div className="block">
                    {displayHours(clinic)}
                  </div>
                </React.Fragment>
              }
              <br/><br/>
              <ClinicButtons clinic={clinic} />
              
            </div>
            {
              showAnnouncements &&
              <div className="text-sm font-semibold tracking-[1px] md:tracking-[2px] mb-8 text-right">
                <Announcements data={clinicAnnouncements} />
              </div>
            }
          </div>
        </div>
      }

      <div className="max-w-6xl mx-auto px-4 pb-8 min-h-[300px]">
        <Clinics globalData={globalData} clinic={clinic} />
        <HomeMap clinics={globalData.clinics} activeClinic={clinic} />
        {
          showAnnouncements && !clinic &&
          <div className="text-sm font-semibold tracking-[1px] md:tracking-[2px] mb-8 text-right">
            <Announcements data={clinicAnnouncements} />
          </div>
        }
      </div>
      
      
      <Social globalData={globalData} clinic={clinic} />
      <Services globalData={globalData} clinic={clinic} />
      <About globalData={globalData} clinic={clinic} />
      <MissionStatement globalData={globalData} clinic={clinic} data={data.missionStatements}/>
    </AppFrame>
  )

}